export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10; // page size
export const KEY = '755606f0-6248-476f-a76d-ffbdf3911923';
export const MODAL_CLOSE_SEC = 2.5;
